<ng-container *transloco="let t;">
  <app-detail-view [loading]="loading" [messages]="messages" (closed)="onClose()">

    <div title>
      <h1>
        <span *ngIf="newMode()">{{ t('messageorders.create_messageorder') }}</span>
        <span *ngIf="editMode()">{{ t('common.labels.messageorder') }} <strong>{{ messageorder.title }}</strong></span>
      </h1>
    </div>

    <div details>
      <p-tabView (onChange)="onTabChange($event)" [(activeIndex)]="tabIndex">

          <p-tabPanel header="{{ t('common.labels.basedata') }}" leftIcon="pi pi-sliders-h" [disabled]="isDisabled('basedata')">
            <app-messageorder-new *ngIf="newMode()" [options]="options"></app-messageorder-new>
            <app-messageorder-basedata *ngIf="editMode()" [messageorder]="messageorder" [options]="options" (setEdit)="setEdit($event)"></app-messageorder-basedata>
          </p-tabPanel>

          <p-tabPanel header="{{ t('common.labels.contents') }}" leftIcon="pi pi-align-left" [disabled]="isDisabled('contents') || messageorder === null">
            <app-content-editor *ngIf="editMode()" [owner]="messageorder" [languages]="languages" [mode]="'messageorders'" (setEdit)="setEdit($event)"></app-content-editor>
          </p-tabPanel>

      </p-tabView>
    </div>

  </app-detail-view>
</ng-container>
